import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HttpClient } from '../api/httpClient';
import {
  tariffLoader,
  updateTariffs,
} from '../actions/DescriptionOfMerchandiseActions';
import moment from 'moment';

function getEntryDateUsingPriority({ releaseDate, itDate, entryDate }) {
  return [releaseDate, itDate, entryDate, 0].find((date) => date >= 1000) || 0;
}

function getUtcDateTimestampFromEpoch(epoch) {
  if (!epoch) return '';

  const date = new Date(epoch);
  const formattedDateStr = `${
    date.getUTCMonth() + 1
  }/${date.getUTCDate()}/${date.getUTCFullYear()}`;
  return new Date(formattedDateStr).getTime();
}

function UpdateTariffs({ children, invoiceId, merchandiseId }) {
  const dispatch = useDispatch();
  const currentInvoice = useSelector(
    (state) => state?.DescriptionOfMerchandise?.entrySummaryInvoices
  )?.find((inv) => inv?.invoiceId === invoiceId);

  const entryTypeValues = useSelector((state) => state?.EntryTypeInfo);

  const bolInfo = useSelector((state) => state?.BOLInfo);

  const merchandiseLineItem = currentInvoice?.merchandiseLineItems?.find(
    (lineItem) => lineItem?.merchandiseId === merchandiseId
  );
  const baseHts = merchandiseLineItem?.merchandiseDuties?.find(
    (duty) => duty.isCommodityDuty === 1
  );
  const additionalHts = merchandiseLineItem?.merchandiseDuties?.filter(
    (duty) => duty.isCommodityDuty === 2
  );
  // exact logic for entry date
  const itDate = getUtcDateTimestampFromEpoch(bolInfo?.itDate?.epochs);
  const releaseDate = getUtcDateTimestampFromEpoch(entryTypeValues?.releaseDate?.epochs);
  const entryDate = getUtcDateTimestampFromEpoch(entryTypeValues?.summaryDate?.epochs)
  //updateHTS
  const updateHTS = async (payload) => {
    try {
      const htsCode = payload?.htsNo || baseHts?.htsus;
      const countryOfOrigin =
        payload?.countryOfOrigin || merchandiseLineItem?.countryOfOrigin;
      const countryOfSmelt =
        merchandiseLineItem?.importerAdditionalDeclarationDetails?.importerAdditionalDeclarationDetail
          ?.find((d) => d.typeCode === 'ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL')
          ?.aluminumSmeltAndCastCountryDetail?.primaryCountryOfSmelt?.trim() ||
        merchandiseLineItem?.importerAdditionalDeclarationDetails?.importerAdditionalDeclarationDetail?.find(
          (d) => d.typeCode === 'STEEL_MELT_AND_POUR_COUNTRY_DETAIL'
        )?.steelMeltAndPourCountryDetail?.countryOfMeltAndPourCode;

      const countryOfCast =
        payload?.countryOfCast ||
        merchandiseLineItem?.importerAdditionalDeclarationDetails
          ?.importerAdditionalDeclarationDetail?.[0]
          ?.aluminumSmeltAndCastCountryDetail?.countryOfCast;
      const tradeAgreement =
        payload?.tradeAgreement || merchandiseLineItem?.productClaimCode;
      if (Object.keys(payload).includes('htsNo') && !payload?.htsNo) return;
      dispatch(tariffLoader(true));

      // if (countryOfOrigin === 'CN') return;

      const entryDateEpoch = getEntryDateUsingPriority({
        releaseDate,
        itDate,
        entryDate,
      });

      const response = await HttpClient.custom({
        data: {
          eventMessage: {
            htsCode,
            countryOfOrigin,
            smeltCountryOfOrigin: countryOfSmelt || countryOfCast,
            tradeAgreement: ['NA', 'NONE']?.includes(tradeAgreement)
              ? undefined
              : tradeAgreement,
            entryDate: entryDateEpoch
              ? moment(entryDateEpoch).format('MM-DD-YYYY')
              : '',
          },
          eventType: 'GET_HTS_ADDITIONAL_INFO',
          eventTime: Date.now(),
        },
      });
      const tariffs = response?.data?.eventMessage?.allAdditionalCodes || [];
      if (tariffs?.length && additionalHts?.length) {
        if (
          !window.confirm(
            'Confirm replacement: Apply tariffs from the HTS code and overwrite the existing ones?'
          )
        ) {
          dispatch(tariffLoader(false));
          return;
        }
      }
      await dispatch(
        updateTariffs({ tariffs, invoiceId, merchandiseId, additionalHts })
      );
      dispatch(tariffLoader(false));
    } catch (e) {
      console.log(e);
      dispatch(tariffLoader(false));
    } finally {
      dispatch(tariffLoader(false));
    }
  };

  return <div>{children({ updateHTS: updateHTS })}</div>;
}

export default UpdateTariffs;
